<template>
    <div class="flex flex-col items-center gap-0.5 w-[127px] cursor-pointer">
        <span class="flex flex-col items-center justify-center w-full h-[88px] p-4 text-slate-400">
            <font-awesome-icon widthAuto :icon="faImage" size="5x" />
        </span>
        <span class="flex flex-col items-center justify-center w-full h-[33px] p-4 text-sm text-slate-900">
            <slot></slot>
        </span>
    </div>
</template>
<script setup>
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>
